import $ from 'jquery';

$(document).ready(function() {
    $('.download-link').on('click', function(e) {
        e.preventDefault(); // Prevent the default anchor behavior

        // Get the dynamic file URL from the data attribute
        var fileUrl = $(this).data('file-url'); 
        
        // Construct the URL to the PHP script for download, passing the dynamic file URL as a query parameter
        var downloadUrl = '/download.php?file=' + encodeURIComponent(fileUrl);

        // Redirect to the PHP script to trigger the download
        window.location.href = downloadUrl;
    });
});